import { useCallback } from 'react'
import { confirmDialogVar } from './confirm-reactive-var'

export type ConfirmParams = {
  title: string
  message: string
  confirmButtonText: string
  confirmIsDanger?: true
  cancelButtonText: string
  onConfirm: () => void
  onCancel?: () => void
}

export type SyncConfirmParams = {
  title: string
  message: string
  confirmButtonText: string
  confirmIsDanger?: true
  cancelButtonText: string
}
export function useSyncConfirm() {
  const confirmDialog = useConfirm()

  const syncConfirm = useCallback(
    async (params: SyncConfirmParams) => {
      try {
        return await new Promise<boolean>((resolve) => {
          try {
            confirmDialog({
              ...params,
              onConfirm: () => resolve(true),
              onCancel: () => resolve(false),
            })
          } catch (e) {
            resolve(false)
          }
        })
      } catch (e) {
        return false
      }
    },
    [confirmDialog],
  )

  return syncConfirm
}

export default function useConfirm() {
  const confirm = useCallback((params: ConfirmParams) => {
    const dialogs = confirmDialogVar()
    let newKey = 'ConfirmDialog-0'
    const last = dialogs[dialogs.length - 1]
    if (last) {
      newKey = last.key + '-0'
    }
    const newDialog = {
      key: newKey,
      title: params.title,
      message: params.message,
      confirmButtonText: params.confirmButtonText,
      confirmIsDanger: params.confirmIsDanger,
      cancelButtonText: params.cancelButtonText,
      onConfirm: params.onConfirm,
      onCancel: params.onCancel,
    }
    confirmDialogVar([...dialogs, newDialog])
  }, [])

  return confirm
}
